import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "@/utils/useAxios";
import {
  IMerchantOverview,
  IMerchantTerminal,
  IMerchantTransaction,
} from "./types";

import { errorLogger } from "@/utils/helper";
import { toast } from "react-toastify";

export const useChangePassword = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  return useMutation({
    mutationFn: async (payload: any) => {
      try {
        const response = await axios.put(
          "/clientmerchants/change/password",
          payload
        );
        return response.data.data as any;
      } catch (error) {
        errorLogger(error);
      }
    },
    onSuccess: () => {
      toast.success("Password Changed Successfully");
      onSuccess?.();
    },
  });
};

export const useGetAllMerchantUsers = () => {
  return useQuery({
    queryKey: ["get_merchant_users"],
    queryFn: async () => {
      try {
        const response = await axios.get("/clientmerchants/merchant/users");
        return response.data.data as any;
      } catch (error) {
        errorLogger(error);
      }
    },
    placeholderData: (previousData) => previousData,
  });
};

export const useGetAllMerchantTransaction = (filter?: {
  size: number;
  page: number;
  fromDate?: string;
  toDate?: string;
  cardtype?: string;
  status?: string;
  transactionId?: string;
  terminalId?: string;
  search?: string;
  responseCode?: string;
  paymentType?: string;
  rrn?: string;
  stan?: string;
  type?: string;
  limit?: number;
}) => {
  return useQuery({
    queryKey: ["get_merchant_tx", { ...filter }],
    queryFn: async () => {
      try {
        const response = await axios.get("/clientmerchants/transactions", {
          params: {
            ...filter,
          },
        });
        return response.data.data as IMerchantTransaction;
      } catch (error) {
        errorLogger(error);
      }
    },
    placeholderData: (previousData) => previousData,
  });
};

export const useGetMerchantDashboardOverview = (filter?: {
  terminalId?: string;
}) => {
  return useQuery({
    queryKey: ["use_fetch_overview", { ...filter }],
    queryFn: async () => {
      try {
        const response = await axios.get("/clientmerchants/dashboard", {
          params: {
            ...filter,
          },
        });
        return response.data.data as IMerchantOverview;
      } catch (error) {
        errorLogger(error);
      }
    },
    placeholderData: (previousData) => previousData,
  });
};

export const useGetAllMerchantTerminal = (filter?: {
  size: number;
  page: number;
}) => {
  return useQuery({
    queryKey: ["get_merchant_terminals", { ...filter }],
    queryFn: async () => {
      try {
        const response = await axios.get("/clientmerchants/terminals", {
          params: {
            ...filter,
          },
        });
        return response.data.data as IMerchantTerminal;
      } catch (error) {
        errorLogger(error);
      }
    },
    placeholderData: (previousData) => previousData,
  });
};

export const useDownloadTransactionReciept = ({
  id,
  onSuccess,
}: {
  id: string;
  onSuccess: (data: any) => void;
}) => {
  return useMutation({
    mutationFn: async () => {
      try {
        const response = await axios.get(
          "clientmerchants/download/transaction/" + id
        );
        return response.data as any;
      } catch (error) {
        errorLogger(error);
      }
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
  });
};
